var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-banner',{attrs:{"data":_vm.banner}}),_c('the-bar'),_c('the-games',{attrs:{"data":_vm.games}}),_c('the-contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }